import { __decorate } from "tslib";
import Money from '@/components/Money.vue';
import ColorPopover from "../../../Company/Configurator/ColorPopover.vue";
import ConfirmableButton from "@/components/ConfirmableButton.vue";
import TeamSelect from "@/components/TeamSelect.vue";
import { Component, Emit, Inject, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
let TreatmentCard = class TreatmentCard extends Vue {
    value;
    item;
    tooth;
    stage;
    editMode;
    printMode;
    addTreatmentBtn;
    treatmentIdx;
    openBrowser;
    user;
    get checked() {
        return !!this.value.find(el => el.tooth === this.tooth
            && el.idx === this.treatmentIdx
            && el.stage === this.stage
            && el.treatment._id === this.item.treatment._id);
    }
    saveChange(item) {
        return item;
    }
    emitInput(values) {
        return values;
    }
    selectTreatment(selected) {
        if (this.editMode)
            return;
        if (selected) {
            if (!this.item.completed && !this.item.userId) {
                this.item.userId = (this.user || {})._id;
            }
            return this.emitInput(this.value.concat({
                tooth: this.tooth,
                idx: this.treatmentIdx,
                stage: this.stage,
                treatment: this.item.treatment
            }));
        }
        return this.emitInput(this.value.filter(el => !(el.tooth === this.tooth
            && el.idx === this.treatmentIdx
            && el.stage === this.stage
            && el.treatment._id === this.item.treatment._id)));
    }
    markDone() {
        let item = this.$copy(this.item);
        item.completed = true;
        item.completedAt = new Date().toString();
        this.saveChange(item);
    }
    remove() {
        this.saveChange(null);
    }
    setKeyValue(key, value) {
        this.saveChange({ ...this.item, [key]: value });
    }
};
__decorate([
    Prop({ type: Array })
], TreatmentCard.prototype, "value", void 0);
__decorate([
    Prop({ type: Object })
], TreatmentCard.prototype, "item", void 0);
__decorate([
    Prop({ type: [Number, String] })
], TreatmentCard.prototype, "tooth", void 0);
__decorate([
    Prop({ type: [Number, String] })
], TreatmentCard.prototype, "stage", void 0);
__decorate([
    Prop({ type: Boolean })
], TreatmentCard.prototype, "editMode", void 0);
__decorate([
    Prop({ type: Boolean })
], TreatmentCard.prototype, "printMode", void 0);
__decorate([
    Prop({ type: Boolean })
], TreatmentCard.prototype, "addTreatmentBtn", void 0);
__decorate([
    Prop({ type: Number })
], TreatmentCard.prototype, "treatmentIdx", void 0);
__decorate([
    Inject('openBrowser')
], TreatmentCard.prototype, "openBrowser", void 0);
__decorate([
    Emit('saveChange')
], TreatmentCard.prototype, "saveChange", null);
__decorate([
    Emit('input')
], TreatmentCard.prototype, "emitInput", null);
TreatmentCard = __decorate([
    Component({
        components: {
            Money,
            TeamSelect,
            ColorPopover,
            ConfirmableButton
        },
        computed: {
            ...mapState('auth', ['user'])
        },
    })
], TreatmentCard);
export default TreatmentCard;
